import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { FaLanguage, FaUserPen, FaBookOpen } from "react-icons/fa6";
import AOS from "aos";
import "aos/dist/aos.css";

const features = [
  {
    title: "Language Segmentation",
    description:
      "Curated collections by language; French, Arabic, Japanese, Spanish, and more.",
    icon: FaLanguage,
  },
  {
    title: "Author Insights",
    description:
      "Brief bios to understand the mind behind each masterpiece.",
    icon: FaUserPen,
  },
  {
    title: "Concise Summaries",
    description:
      "Readable summaries that respect your time while enriching knowledge.",
    icon: FaBookOpen,
  },
];

const tabs = ["Accessible", "Elegant", "Global"];

export default function ThirdSection() {
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: false, // animation happens only once
    });
  }, []);

  return (
    <section
      id="product"
      className="py-5"
      style={{ backgroundColor: "#ffffff" }}
    >
      <Container>
        {/* Heading */}
        <div className="text-center mb-5" data-aos="fade-up">
          <div
            className="d-inline-block mb-3 px-3 py-1 rounded-pill border shadow-sm"
            style={{ backgroundColor: "#ffffff", fontWeight: 600 }}
            data-aos="zoom-in"
            data-aos-delay="100"
          >
            Inside Biblivium
          </div>
          <h2 className="fw-bold mb-3" data-aos="fade-up" data-aos-delay="200">
            Smart Features Included
          </h2>
          <p
            className="text-muted mx-auto"
            style={{ maxWidth: "600px" }}
            data-aos="fade-up"
            data-aos-delay="300"
          >
            Everything you need to explore the world of literature effortlessly.
          </p>
        </div>

        {/* Tabs */}
        <div
          className="d-flex justify-content-center gap-3 flex-wrap mb-4"
          data-aos="fade-up"
          data-aos-delay="400"
        >
          {tabs.map((tab, index) => (
            <Button
              key={index}
              variant={activeTab === index ? "dark" : "outline-secondary"}
              onClick={() => setActiveTab(index)}
              className="px-4 py-2 rounded-pill"
            >
              {tab}
            </Button>
          ))}
        </div>

        {/* Feature Cards */}
        <Row className="g-4 justify-content-center">
          {features.map((feature, idx) => {
            const Icon = feature.icon;
            return (
              <Col
                key={idx}
                xs={12}
                md={6}
                lg={4}
                data-aos="zoom-in"
                data-aos-delay={500 + idx * 100} // stagger animations
              >
                <div
                  className="text-center p-4 h-100 shadow-sm rounded-4"
                  style={{
                    transition: "transform 0.3s ease",
                    cursor: "pointer",
                  }}
                >
                  <Icon size={48} className="mb-3" style={{ color: "#1c1c1c" }} />
                  <h5 className="fw-semibold">{feature.title}</h5>
                  <p className="text-secondary mb-0">{feature.description}</p>
                </div>
              </Col>
            );
          })}
        </Row>
      </Container>

      {/* Hover effect */}
      <style>{`
        .rounded-4:hover {
          transform: translateY(-6px);
        }
      `}</style>
    </section>
  );
}
